import {types} from "mobx-state-tree";
import {AuditMetaData} from "../AuditMetaData";
import {TagModel} from "../tags/TagModel";

const GroupData = types.model('group', {
  groupUuid: types.maybe(types.string)
})

export const Utm = types.model('Utm', {
  uuid: types.identifier,
  name: types.optional(types.string, ""),
  label: types.maybe(types.string),
  campaign: types.optional(types.string, ""),
  source: types.optional(types.string, ""),
  medium: types.optional(types.string, ""),
  term: types.optional(types.string, ""),
  content: types.optional(types.string, ""),
  nameIsInvalid: types.optional(types.boolean, false),
  campaignIsInvalid: types.optional(types.boolean, false),
  sourceIsInvalid: types.optional(types.boolean, false),
  mediumIsInvalid: types.optional(types.boolean, false),
  isEditable: types.optional(types.boolean, false),
  isExclusivelyGroupOwned: types.optional(types.boolean, false),
  owner: types.maybe(GroupData),
  _audit: types.maybeNull(AuditMetaData),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  tags: types.optional(types.array(types.safeReference(types.late(() => TagModel))), []),
  utmParametersConfigs: types.optional(types.model({
    campaignSelectValue: types.maybe(types.frozen()),
    sourceSelectValue: types.maybe(types.frozen()),
    mediumSelectValue: types.maybe(types.frozen()),
    termSelectValue: types.maybe(types.frozen()),
    contentSelectValue: types.maybe(types.frozen())
  }), {}),
  batchEditCampaignNochanges: types.optional(types.boolean, false), // those 5 are only for recording which user selected green check or red cross in batch edit utm
  batchEditSourceNochanges: types.optional(types.boolean, false),
  batchEditMediumNochanges: types.optional(types.boolean, false),
  batchEditTermNochanges: types.optional(types.boolean, false),
  batchEditContentNochanges: types.optional(types.boolean, false),
  removeUTM: types.optional(types.boolean, false),
}).actions((self) => ({
  // updateInput(inputType, e) {
  //   self[inputType] = e.target.value
  //   if (inputType === 'name' || inputType === 'campaign' || inputType === 'source' || inputType === 'medium' || inputType === 'content') {
  //     self[`${inputType}IsInvalid`] = !self.doesInputHaveLength(inputType)
  //   }
  // },
  updateInput(inputType, valueOrEvent) {
    const value = typeof valueOrEvent === "string" ? valueOrEvent : valueOrEvent.target.value;
    self[inputType] = value;

    if (["name", "campaign", "source", "medium", "content"].includes(inputType)) {
      self.utmParametersConfigs[`${inputType}IsInvalid`] = !self.doesInputHaveLength(inputType);
    }
  },
  setNameIsInvalid(bool) {
    self.nameIsInvalid = bool
  },
  hydrateUtm(utm) {
    self.name = utm?.name
    self.campaign = utm?.campaign
    self.source = utm?.source
    self.medium = utm?.medium
    self.term = utm?.term
    self.content = utm?.content
    self.campaignIsInvalid = false
    self.sourceIsInvalid = false
    self.mediumIsInvalid = false
    self.utmParametersConfigs.campaignSelectValue = utm?.utmParametersConfigs?.campaignSelectValue ?? null
    self.utmParametersConfigs.sourceSelectValue = utm?.utmParametersConfigs?.sourceSelectValue ?? null
    self.utmParametersConfigs.mediumSelectValue = utm?.utmParametersConfigs?.mediumSelectValue ?? null
    self.utmParametersConfigs.termSelectValue = utm?.utmParametersConfigs?.termSelectValue ?? null
    self.utmParametersConfigs.contentSelectValue = utm?.utmParametersConfigs?.contentSelectValue ?? null
    self.batchEditCampaignNochanges = utm?.batchEditCampaignNochanges 
    self.batchEditSourceNochanges = utm?.batchEditSourceNochanges 
    self.batchEditMediumNochanges = utm?.batchEditMediumNochanges 
    self.batchEditTermNochanges = utm?.batchEditTermNochanges 
    self.batchEditContentNochanges = utm?.batchEditContentNochanges  
  },
  updateSelectValue(inputType, selectedOption) {
    self.utmParametersConfigs[`${inputType}SelectValue`] = selectedOption;
  },
  validateUtmModel() {
    let isValid = true;
    // if (self.campaign === "") {
    //   self.campaignIsInvalid = true;
    //   isValid = false;
    // }
    // if (self.source === "") {
    //   self.sourceIsInvalid = true;
    //   isValid = false;
    // }
    // if (self.medium === "") {
    //   self.mediumIsInvalid = true;
    //   isValid = false;
    // }
    return isValid;
  },
  reset() {
    self.resetCampaign();
    self.resetSource();
    self.resetMedium();
    self.resetTerm();
    self.resetContent();
  },
  resetCampaign() {
    self.campaign = "";
    self.utmParametersConfigs.campaignSelectValue = null;
  },
  resetSource() {
    self.source = "";
    self.utmParametersConfigs.sourceSelectValue = null;
  },
  resetMedium() {
    self.medium = "";
    self.utmParametersConfigs.mediumSelectValue = null;
  },
  resetTerm() {
    self.term = "";
    self.utmParametersConfigs.termSelectValue = null;
  },
  resetContent() {
    self.content = "";
    self.utmParametersConfigs.contentSelect = null;
  }
})).views((self) => ({
  doesInputHaveLength(inputType) {
    return self[inputType]?.length > 0;
  },
  doesUtmHaveValue() {
    return !!(self.campaign?.length > 0 ||
      self.source?.length > 0 ||
      self.medium?.length > 0 ||
      self.term?.length > 0 ||
      self.content?.length > 0 ||
      self.utmParametersConfigs.campaignSelectValue ||
      self.utmParametersConfigs.sourceSelectValue ||
      self.utmParametersConfigs.mediumSelectValue ||
      self.utmParametersConfigs.termSelectValue ||
      self.utmParametersConfigs.contentSelectValue ||
      self.batchEditCampaignNochanges ||
      self.batchEditSourceNochanges ||
      self.batchEditMediumNochanges ||
      self.batchEditTermNochanges ||
      self.batchEditContentNochanges);
  },
  grabUtmForCode() {
    return Utm.create({
      uuid: "utmForCode",
      campaign: self.campaign,
      source: self.source,
      medium: self.medium,
      term: self.term,
      content: self.content,
      utmParametersConfigs: {
        campaignSelectValue: self.utmParametersConfigs.campaignSelectValue,
        sourceSelectValue: self.utmParametersConfigs.sourceSelectValue,
        mediumSelectValue: self.utmParametersConfigs.mediumSelectValue,
        termSelectValue: self.utmParametersConfigs.termSelectValue,
        contentSelectValue: self.utmParametersConfigs.contentSelectValue
      },
      batchEditCampaignNochanges: self.batchEditCampaignNochanges,
      batchEditSourceNochanges: self.batchEditSourceNochanges,
      batchEditMediumNochanges: self.batchEditMediumNochanges,
      batchEditTermNochanges: self.batchEditTermNochanges,
      batchEditContentNochanges: self.batchEditContentNochanges
    })
  },
  isInputInvalid(inputType) {
    return self[`${inputType}IsInvalid`]
  }

}));
